<template>
  <div>
    <h3 class="tw-mb-3">
      {{ $t('dashboard.messaging_metrics.average_response_time', { duration: $dayjsFormatMetricDuration(averageResponseTime, $t) }) }}
    </h3>
    <MetricFilters
      class="tw-mb-3"
      filters-state-relative-path="messagingMetricsFilters"
    />
    <AdministrationTableHeader
      store-path="v2/admin/dashboard"
      filters-state-relative-path="messagingMetricsFilters"
      filters-mutation-relative-path="sortMessagingMetricsByUser"
      :columns="columns"
      :need-to-translate-column-title="false"
    />
    <div class="tw-border tw-border-gray dark:tw-border-dm-gray tw-overflow-hidden tw-rounded-3xl">
      <template
        v-for="(userMetric, index) in metricsByUser"
        :key="userMetric.actor_id"
      >
        <div
          v-if="index > 0"
          class="tw-w-full tw-h-px tw-bg-gray dark:tw-bg-dm-gray"
        />
        <div
          class="tw-flex tw-items-center tw-py-1.5 tw-px-3 tw-gap-6 hover:tw-bg-light dark:hover:tw-bg-dm-light"
        >
          <div
            class="tw-flex tw-items-center tw-leading-5 tw-tracking-normal"
            :style="`width: ${columns[0].width}`"
          >
            {{ userMetric.fullname }}
          </div>

          <div :style="`width: ${columns[1].width}`">
            {{ $dayjsFormatMetricDuration(userMetric.avg_resp, $t) }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import AdministrationTableHeader from '@/components/Administration/components/AdministrationTableHeader.vue';
import { mapGetters, mapState } from 'vuex';
import { messagingMetricsTableColumns } from '@/views/admin/dashboard/constants';
import { clientCompanyFilterMixin } from '@/mixins/clientCompanyFilterMixin';
import MetricFilters from '@/views/admin/dashboard/components/MetricFilters.vue';

export default {
  name: 'MessagingMetrics',
  components: { MetricFilters, AdministrationTableHeader },
  mixins: [clientCompanyFilterMixin],
  computed: {
    ...mapState({
      averageResponseTime: (state) => state.v2.admin.dashboard.averageMessageResponseTime,
      metricsByUser: (state) => state.v2.admin.dashboard.messagingMetricsByUser,
      messagingMetricsFilters: (state) => state.v2.admin.dashboard.messagingMetricsFilters,
    }),
    ...mapGetters({
      clientCompanies: 'v2/admin/cms/clients/companies/selectOptions',
    }),
    columns() {
      return messagingMetricsTableColumns(this.$t);
    },
  },
};
</script>
